import { BankInfo, PostBankInfo } from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';
import axios from 'axios';

interface BankInfoResponse {
  results: BankInfo[];
  page: number;
  limit: number;
  totalPages: number;
  totalResults: number;
}

const endpoint = '/v1/bank-info';

export const createBankInfo = async (
  data: PostBankInfo
): Promise<BankInfo> => {
  try {
    const response = await axiosApiInstancePrivate.post<BankInfo>(`/v1/bank-info`, data);
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      throw err?.response?.data;
    }
    throw err;
  }
};

export const getBankInfos = async ({
  page,
  pageSize,
  group = '',
}: {
  page: number;
  pageSize: number;
  group: string;
}): Promise<BankInfoResponse> => {
  try {
    const params: { page: number; limit: number; group?: string } = {
      page,
      limit: pageSize,
    };
    if (group) {
      params['group'] = group;
    }
    const response = await axiosApiInstancePrivate.get<BankInfoResponse>(
      endpoint,
      { params }
    );
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      throw err?.response?.data;
    }
    throw err;
  }
};

export const updateBankInfo = async (
  id: string,
  data: PostBankInfo
): Promise<BankInfo> => {
  try {
    const end_point = `${endpoint}/${encodeURIComponent(id)}`;
    const response = await axiosApiInstancePrivate.patch<BankInfo>(
      end_point,
      data
    );
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      throw err?.response?.data;
    }
    throw err;
  }
};

export const deleteBankInfo = async (id: string): Promise<BankInfo> => {
  try {
    const end_point = `${endpoint}/${encodeURIComponent(id)}`;
    const response = await axiosApiInstancePrivate.delete<BankInfo>(
      end_point
    );
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      throw err?.response?.data;
    }
    throw err;
  }
};
